import { toast } from "react-toastify";
import { all, put, takeLatest } from "redux-saga/effects";

// Apis
import {
  addOrgMediaImagesFn,
  getOrgMediaInfoFn,
  downloadOrgMediaPdfReportFn,
  refreshOrgAllMediaInfoFn,
} from "../../apis/OrgMediaAPI";
import { getTrafficInfoByRoadId } from "../../apis/CampaignMediaAPI";

// Constants and Utils
import { OrgMedia } from "../../constants/action-constants/org/OrgMediaActionConstants";
import { setErrorStatusCode } from "../../utils/ErrorUtils";
import { getErrorMessage } from "../../utils/util";

/**
 *  Org media info
 */
export function* getOrgMediaInfo(action) {
  const { mediaId, orgId } = action.payload;

  try {
    // Api call
    const orgMediaInfo = yield getOrgMediaInfoFn(orgId, mediaId);

    const roadSegmentTrafficInfo = {};

    // Api to get traffic data
    if (orgMediaInfo.roadSegmentIds?.length > 0) {
      const roadSegmentId = orgMediaInfo.roadSegmentIds[0];
      const trafficInfoOfRoad = yield getTrafficInfoByRoadId(roadSegmentId);
      Object.assign(roadSegmentTrafficInfo, trafficInfoOfRoad);
    }

    yield put({
      type: OrgMedia.GET_ORG_MEDIA_INFO_SUCCESS,
      payload: { orgMediaInfo, roadSegmentTrafficInfo },
    });
  } catch (error) {
    // stores the error and render the error image when the api fails
    setErrorStatusCode(error);

    yield put({
      type: OrgMedia.GET_ORG_MEDIA_INFO_FAILURE,
      payload: error,
    });
  }
}

// Add-Org Media Images
export function* addOrgMediaImages(action) {
  const { orgId, mediaId, files } = action.payload;

  try {
    const sellerMediaFileItems = yield addOrgMediaImagesFn(
      orgId,
      mediaId,
      files
    );

    yield put({
      type: OrgMedia.ADD_ORG_MEDIA_IMAGES_SUCCESS,
      sellerMediaFileItems: sellerMediaFileItems,
    });
    toast.success("Successfully Added");
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    yield put({
      type: OrgMedia.ADD_ORG_MEDIA_IMAGES_FAILURE,
      payload: errorMessage,
    });
    toast.error(errorMessage);
  }
}

export function* downloadOrgMediaPdfReport(action) {
  try {
    const {
      orgId,
      mediaId,
      radius,
      isSentViaEmail,
      emailIds = [],
    } = action.payload;

    const data = yield downloadOrgMediaPdfReportFn(
      orgId,
      mediaId,
      radius,
      isSentViaEmail,
      emailIds
    );

    yield put({
      type: OrgMedia.DOWNLOAD_ORG_MEDIA_PDF_REPORT_SUCCESS,
      payload: { isSentViaEmail, reportData: data },
    });
  } catch (err) {
    const errMsg = getErrorMessage(err);
    yield put({
      type: OrgMedia.DOWNLOAD_ORG_MEDIA_PDF_REPORT_FAILURE,
      payload: err,
    });
    toast.error(errMsg);
  }
}

// Refresh Media
export function* refreshOrgAllMediaInfo(action) {
  try {
    const { orgId } = action.payload;

    yield refreshOrgAllMediaInfoFn(orgId);

    yield put({
      type: OrgMedia.REFRESH_ORG_ALL_MEDIA_INFO_SUCCESS,
    });
    toast.success(
      "Successfully Triggered a task to refresh media, Please check the updated media after one hour"
    );
  } catch (err) {
    yield put({
      type: OrgMedia.REFRESH_ORG_ALL_MEDIA_INFO_FAILURE,
      payload: { error: err },
    });
  }
}

export default function* root() {
  yield all([
    takeLatest(OrgMedia.GET_ORG_MEDIA_INFO, getOrgMediaInfo),
    takeLatest(OrgMedia.ADD_ORG_MEDIA_IMAGES, addOrgMediaImages),
    takeLatest(
      OrgMedia.DOWNLOAD_ORG_MEDIA_PDF_REPORT,
      downloadOrgMediaPdfReport
    ),
    takeLatest(OrgMedia.REFRESH_ORG_ALL_MEDIA_INFO, refreshOrgAllMediaInfo),
  ]);
}
